import mixins from 'synergycms_core/src/less/mixins';

export default {
    timeoutModalTable: {
        display: 'table',
        height: '100%',
        width: '100%',
    },
    timeoutModalTableCell: {
        display: 'table-cell',
        verticalAlign: 'middle',
        textAlign: 'center',
        padding: '20px',
        position:'relative'
    },
    timeoutModalWhite: {
        padding: '50px 30px',
        margin: '0 auto',
        background: '#ffffff',
        textAlign: 'center',
        position:'relative',
        fontFamily: data => data.fontFamily1,
        '@media (min-width:601px)': {
            padding: '45px',
            maxWidth: '470px',
            boxSizing:'border-box'
        }
    },
    amenityIconTitle:{
        fill: data => data.mainColor,
        width: '45px',
        height: '45px',
        marginBottom: '30px',
        '@media (min-width:601px)': {
            width: '65px',
            height: '65px',
        }
    },
    timeoutModalTitle: {
        display: "block",
        textTransform: "uppercase",
        color: "#000",
        fontSize: '18px',
        fontWeight: '400',
        lineHeight:'21px',
        marginBottom: '25px',
        '@media (min-width:601px)': {
            fontSize: '20px',
            lineHeight:'23px'
        }
    },
    timeoutModalLogo: {
        display: 'block',
        textTransform: 'uppercase',
        fontWeight: '500',
        marginBottom: '36px',
        color: '#000'
    },
    centerText:{},
    timeoutModalInfo: {
        display: 'block',
        fontSize: '13px',
        fontWeight:400,
        color: '#8c8c8c',
        lineHeight: '15px',
        marginBottom: '11px',
        textAlign:'left',
        paddingTop:'10px',
        '&$centerText':{
            textAlign: 'center',
        },
        '@media (min-width:601px)': {
            fontSize:'14px',
            lineHeight:'16px'
        },
        '&:first-letter':{
        textTransform: 'capitalize',
      }
    },
    sendMailContainer: {
        margin:'20px 0 0',
        '@media (min-width:601px)': {
            marginTop:'16px'
        }
    },
    timeoutAcceptButton: {
        border: data => '1px solid ' + data.secondColor,
        backgroundColor: data => data.secondColor,
        color: '#fff',
        ...mixins.boxSizing('content-box'),
        textTransform: 'uppercase',
        cursor: 'pointer',
        textAlign: 'center',
        padding: '16px',
        fontSize:'15px',
        lineHeight:'17px',
        fontWeight:'500',
        margin:'25px 0 35px',
        '&:hover': {
            backgroundColor: 'transparent',
            ...mixins.transitionAll(),
            color: data => data.secondColor
        },
        '@media (min-width:601px)': {
            margin:'20px 0 30px'
        }
    },
    amenityIcon:{
        width:'20px',
        height:'18px',
        position:'absolute',
        left:0,
        top:'50%',
        fill: data => data.mainColor,
        marginTop:'-9px'
    },
    timeoutList:{
        listStyle:'none',
        margin:0,
        padding:'0 0 0 12px',
        '& > li':{
            '& > span':{
                '& > svg':{
                    height:'18px',
                    fill: data => data.mainColor,
                    '& path':{
                        fill: data => data.mainColor,
                    }
                }
            }
        }
    },
    timeoutListInfo:{
        composes:'$timeoutModalInfo',
        position:'relative',
        margin:'0',
        padding:'9px 0 10px 30px',
    },
    closeButton:{
        width:'22px',
        top:'20px',
        right:'30px',
        position: 'absolute',
        zIndex: '600',
        background: 'none',
        cursor: 'pointer',
        color: data => data.mainColor,
        border: '0',
        fontSize: '22px',
        '&:lang(ar)':{
            left:'15px',
            right:'auto',
            float:'left'
        }
    },
    socialLogo:{
        width:'26px',
        height:'26px',
        display:'block',
        '& > svg':{
            width:'26px',
            height:'26px',
            fill: data => data.mainColor,
        },
    },
    socialIconList:{
        display:'flex',
        flexWrap:'nowrap',
        justifyContent:'space-between',
        alignContent:'center',
        listStyle:'none',
        margin:0,
        padding:'35px 0 0',
        '@media(min-width:801px)':{
            paddingTop:'37px',
            maxWidth:'235px',
            margin:'0 auto'
        }
    },
    socialIconElement:{
        padding:'0 12px',
        '&:last-of-type':{
            paddingRight:'0'
        }
    }
}